import ApiService from "../api-service";
import { BASE_URL } from "../../../config";
import {
	TOP,
	END,
	DEFAULT_ERROR_MESSAGE,
	JEET_11_CAPTAIN
} from "@/store/config";
import { initRazorPayModal } from "../razorpay";
import {
	CREATE_ORDER,
	INITIATE_PAYMENT,
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	FETCH_JEET11_PARTNER_TRANSACTION_HISTORY,
	FETCH_JEET11_USER_BY_PHONE,
	PAY_JEET11_USER,
	SHOW_ALERT,
	ADD_MONEY,
	JEET11_PAYMENT_SEND_OTP,
	RESET_JEET11_SEARCHED_USER,
	RESET_JEET11_MODULE,
	FETCH_JEET11_DISTRIBUTOR_RETAILER_LIST,
	FETCH_JEET11_PARTNER_RETAILER_TRANSACTION_HISTORY,
	GENERATE_MPIN,
	GENERATE_MPIN_OTP,
	UPDATE_ROLES,
	UPDATE_MAPPING,
	FETCH_RETAIL_BANNERS,
	CHECK_PAYMENT_STATUS,
	FETCH_CAPTAIN_TARGETS,
	UPLOAD_USER_STORY,
	FETCH_USER_STORIES,
	DELETE_USER_STORY,
	FETCH_JEET11_PARTNER_RECHARGE_HISTORY,
	RESET_JEET11_PARTNER_RECHARGE_HISTORY,
	SET_JEET11_USER_PROFILE,
	RESET_JEET11_USER_PROFILE,
	SEND_NOTIFICATION,
	DOWNLOAD_INVOICE,
	DOWNLOAD_CREDIT_NOTE,
	DOWNLOAD_GST_INVOICE,
	FETCH_JEET11_USERS_BY_RETAILER_ID,
	RESET_JEET11_USERS_BY_RETAILER_ID,
	FETCH_RAZORPAY_ACCOUNT_DETAILS,
	CREATE_RAZORPAY_ACCOUNT,
	FETCH_MONTHLY_COMMISSION,
	FETCH_PRODUCTS,
	TRANSFER_COINS,
	TRANSFER_COINS_FETCH_USER_DATA,
	TRANSFER_COINS_FETCH_USER_DATA_MOJ,
	FETCH_DISTRIBUTOR_COMMISION,
	FETCH_USER_MATCH_HISTORY,
	FETCH_USER_RECHARGE_HISTORY,
	FETCH_DSTR_RETAILERS_COMMISSION,
	FETCH_RETAILER_COMMISSION,
	COMMISSION_PAYOUT,
	FETCH_RETAIL_SALARY,
	REVERSE_TRANSACTION,
	UPSERT_PROMOTER_MAPPING,
	GET_NON_VERIFIED_SIGNATURE,
	VERIFY_SIGNATURE,
	GET_PENDING_INVOICES,
	VERIFY_INVOICE,
	FETCH_RETAIL_SCHEMES,
	FETCH_SCHEME_REWARDS,
	TRANSFER_SCHEME_REWARD_CASH,
	FETCH_USER_SETTINGS
} from "../action-types";
import {
	jeet11TransactionHistorySuccess,
	fetchJeet11PartnerWalletDetailsSuccess,
	fetchJeet11UserSuccess,
	payJeet11UserSuccess,
	resetJeet11Module,
	fetchJeet11DistributorRetailerListSuccess,
	fetchJeet11RetailerTransactionHistorySuccess,
	fetchRetailBannersSuccess,
	fetchCaptainTargetsSuccess,
	fetchUserStoriesSuccess,
	deleteUserStorySuccess,
	fetchJeet11PartnerRechargeHistorySuccess,
	setJeet11UserProfile,
	fetchUsersByRetailerIDSuccess,
	resetUsersByRetailerIDSuccess,
	fetchRazorpayAccountDetailsSuccess,
	fetchMonthlyCommissionSuccess,
	fetchProductsSuccess,
	fetchTrasferCoinsUserDataSuccess,
	fetchDistributorCommissionSuccess,
	fetchUserMatchHistorySuccess,
	fetchUserRechargeHistorySuccess,
	fetchDstrRetailersCommissionSuccess
} from "../mutation-types";
import { _getDateTimeFormat, __fileDownload } from "../../utils";
import _get from "lodash/get";
import store from "../../store/index";
import { STATUS } from "../../components/constants";

const state = {
	jeet11PartnerTransactionHistory: {
		list: [],
		offset: undefined
	},
	jeet11PartnerDetails: {},
	jeet11User: null,
	jeet11DistributorRetailerList: {
		list: [],
		offset: undefined
	},
	jeet11PartnerRetailerTransactionHistory: {
		list: [],
		offset: undefined
	},
	jeet11CaptainTargets: {
		levels: []
	},
	userStories: {
		data: [],
		limit: 10,
		canLoadMoreStories: true
	},
	jeet11PartnerRechargeHistory: {
		new: {
			customers: [],
			offset: undefined
		},
		old: {
			customers: [],
			offset: undefined
		},
		rewardHistory: {
			customers: [],
			offset: undefined,
			totalRewardCommission: null
		},
		jeet11UserProfile: null
	},
	usersByRetailerID: {
		users: {
			new: {
				list: [],
				offset: null
			},
			old: {
				list: [],
				offset: null
			}
		}
	},
	razorpayAccountDetails: {},
	monthlyCommission: {
		amount: 0,
		premiumCommission: 0,
		premiumSold: 0,
		executivePremiumSoldLimit: 0
	},
	sharechatProducts: [],
	transferCoinsUserData: {},
	distributorCommission: {
		commissionEarned: 0,
		dstrCommission: {
			oldModel: 0,
			newModel: 0
		},
		nextOffset: null,
		retailerEntries: []
	},
	userHistory: {
		matches: {
			completedMatches: [],
			teamsData: {},
			tournamentsData: {},
			offset: null
		},
		recharges: {
			list: [],
			offset: null
		}
	}
};

export const initialState = Object.assign({}, state);

const getters = {
	isAgency: state => {
		return state.jeet11PartnerDetails.shopType === "agency";
	},
	isMojAgency: state => {
		return state.jeet11PartnerDetails.shopType === "agency_moj";
	},
	isNewSchemeRetailer: state => {
		return state.jeet11PartnerDetails.retailScheme === "new";
	},
	isNewSchemeRetailerCardGames: state => {
		return state.jeet11PartnerDetails.gameRetailScheme === "new";
	},
	isInShopType: state => {
		return state.jeet11PartnerDetails.shopType === "inShop";
	},
	dstrSignatureStatus: state =>
		state.jeet11PartnerDetails.signatureVerified === null ||
		state.jeet11PartnerDetails.signatureVerified === undefined ||
		state.jeet11PartnerDetails.signatureVerified === "rejected"
			? STATUS.REJECTED
			: state.jeet11PartnerDetails.signatureVerified === "pending"
			? STATUS.PENDING
			: STATUS.APPROVED,
	dstrSignatureRemark: state => state.jeet11PartnerDetails.signatureRemarks
};

const actions = {
	[INITIATE_PAYMENT.action]: async ({ dispatch, rootState }, payload) => {
		const isJeet11Distributor = store.getters["auth/isJeet11Distributor"];
		const isJeet11Captain = store.getters["auth/isJeet11Captain"];
		let referrer = "retail";
		if (isJeet11Distributor) referrer = "dstr";
		if (isJeet11Captain) referrer = "captain";
		const useMTPLKey =
			isJeet11Captain &&
			(getters.isAgency(rootState.jeet11) ||
				getters.isMojAgency(rootState.jeet11));
		const isMojAgency = getters.isMojAgency(rootState.jeet11);
		try {
			const razorpayDetails = await dispatch(
				CREATE_ORDER.dispatch,
				payload,
				{
					root: true
				}
			);
			const paymentInfo = await initRazorPayModal({
				amount: payload.amount,
				orderId: razorpayDetails.gatewayTransactionId,
				name: "JEET 11",
				isJeet11Distributor,
				useMTPLKey,
				notes: {
					referrer
				},
				isMojAgency,
				redirectionParams: {
					amount: payload.amount,
					orderId: razorpayDetails.orderId,
					gatewayTransactionId: razorpayDetails.gatewayTransactionId,
					offset: razorpayDetails.offset
				}
			});
			const response = await dispatch(
				ADD_MONEY.dispatch,
				{
					orderId: razorpayDetails.orderId,
					gatewayTransactionId: razorpayDetails.gatewayTransactionId,
					paymentId: paymentInfo.razorpay_payment_id,
					offset: razorpayDetails.offset,
					amount: payload.amount
				},
				{ root: true }
			);
			dispatch(
				FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch,
				{},
				{
					root: true
				}
			);
			const { msg } = response;
			if (msg === "Success") {
				dispatch(
					SHOW_ALERT.dispatch,
					{
						text:
							"Payment Complete, amount will be added in your account soon!"
					},
					{ root: true }
				);
			}
			return { status: "success", orderId: razorpayDetails.orderId };
		} catch (error) {
			if (error) {
				console.error(error);
				return { response: "error" };
			}
		}
	},

	[CHECK_PAYMENT_STATUS.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/paymentStatus";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.code === 200 && data.response) {
					return { status: data.response.status };
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[CREATE_ORDER.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/createOrder";
		const headers = {
			"x-client-app-type": "JEET11"
		};
		if (payload.walletCategory === "games") {
			headers["x-client-app-type"] = "RUMMY";
		}
		if (!payload.walletCategory) delete payload.walletCategory;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[ADD_MONEY.action]: ({ rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/processOrder";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => data.response)
			.catch(err => err);
	},

	[FETCH_JEET11_PARTNER_WALLET_DETAILS.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailer";
		const { p: phoneNo = "", isSchemeRequired = false, isCardGame = 0 } =
			payload || {};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(phoneNo ? { p: phoneNo } : {}),
				...(isSchemeRequired ? { isSchemeRequired: true } : {}),
				...(isCardGame ? { isCardGame } : {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					if (phoneNo) {
						return data.response;
					} else {
						commit(
							fetchJeet11PartnerWalletDetailsSuccess,
							data.response
						);
					}
					return data;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_JEET11_PARTNER_TRANSACTION_HISTORY.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/passbookV2";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload.type === END
					? {
							o: _get(
								rootState,
								"jeet11.jeet11PartnerTransactionHistory.offset"
							)
					  }
					: {}),
				...(payload.userId
					? {
							u: payload.userId
					  }
					: {}),
				...(payload.commission ? { commission: true } : {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(jeet11TransactionHistorySuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_JEET11_USER_BY_PHONE.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getUserByPhone";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				ph: payload.phone,
				c: payload.countryAreaCode
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchJeet11UserSuccess, data.response);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[RESET_JEET11_SEARCHED_USER.action]: ({ commit }) => {
		commit(fetchJeet11UserSuccess, null);
	},

	[JEET11_PAYMENT_SEND_OTP.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = `${BASE_URL}/${
			payload.url ? payload.url : "jeet11-retail"
		}/v1.0.0/sendSms`;
		delete payload.url;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response.msg },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[PAY_JEET11_USER.action]: ({ commit, dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/transferV2";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.status === "success"
				) {
					commit(payJeet11UserSuccess, data.response);
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response.msg },
						{ root: true }
					);
					dispatch(
						RESET_JEET11_SEARCHED_USER.dispatch,
						{},
						{
							root: true
						}
					);
					if (
						rootState.auth.storeType === JEET_11_CAPTAIN &&
						rootState.auth.TEAM_TYPE === "retail"
					) {
						dispatch(
							FETCH_CAPTAIN_TARGETS.dispatch,
							{},
							{ root: true }
						);
					}
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.log(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[RESET_JEET11_MODULE.action]: ({ commit }) => {
		commit(resetJeet11Module);
	},

	[FETCH_JEET11_DISTRIBUTOR_RETAILER_LIST.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailers";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload.type === END
					? {
							o: _get(
								rootState,
								"jeet11.jeet11DistributorRetailerList.offset"
							)
					  }
					: {}),
				...(payload.phoneNo ? { phoneNo: Number(payload.phoneNo) } : {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchJeet11DistributorRetailerListSuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_JEET11_PARTNER_RETAILER_TRANSACTION_HISTORY.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/passbookV2";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				u: payload.retailerId,
				...(payload.type === END
					? {
							o: _get(
								rootState,
								"jeet11.jeet11PartnerRetailerTransactionHistory.offset"
							)
					  }
					: {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchJeet11RetailerTransactionHistorySuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[GENERATE_MPIN.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/generateMpin";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};

		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					data.response &&
					data.response.status === "success"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "MPIN successfully updated!" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[GENERATE_MPIN_OTP.action]: ({ dispatch, rootState }) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/sendMpinOtp";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			// access_token: "5033:UFP7ud4g4xSNUls9",
			params: {}
		};

		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					data.response &&
					data.response.status === "success"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response.msg },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[UPDATE_ROLES.action]: ({ dispatch, rootState }, payload) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/updateRole";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};

		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response === "success") {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Successfully Updated Role!" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.log(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[UPDATE_MAPPING.action]: ({ dispatch, rootState }, payload) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/updateMapping";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};

		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.log(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[FETCH_RETAIL_BANNERS.action]: ({ dispatch, rootState, commit }) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/getBanners";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {}
		};

		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchRetailBannersSuccess, {
						banners: data.response
					});
					return;
				} else if (data.errMsg) {
					commit(fetchRetailBannersSuccess, {
						banners: []
					});
					errMsg = data.errMsg;
					if (
						data.statusCode === 400 &&
						data.errMsg === "No Content"
					) {
						commit(fetchRetailBannersSuccess, {
							banners: []
						});
						return;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_CAPTAIN_TARGETS.action]: ({ dispatch, rootState, commit }) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailerTarget";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchCaptainTargetsSuccess, {
						targets: data.response
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[UPLOAD_USER_STORY.action]: ({ dispatch, rootState }, payload) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/addUserStory";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "UPLOAD SUCCESS" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_USER_STORIES.action]: ({ dispatch, rootState, commit }, payload) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/getUserStory";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload,
				limit: rootState.jeet11.userStories.limit
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchUserStoriesSuccess, {
						...payload,
						stories: data.response
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[DELETE_USER_STORY.action]: ({ dispatch, rootState, commit }, payload) => {
		const endPoint = BASE_URL + "/jeet11-retail/v1.0.0/updateUserStory";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "DELETE USER STORY SUCCESS" },
						{ root: true }
					);
					commit(deleteUserStorySuccess, {
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_JEET11_PARTNER_RECHARGE_HISTORY.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/retailCustomers";
		let rechargeHistoryKey;
		if (payload.rewardHistory) rechargeHistoryKey = "rewardHistory";
		else rechargeHistoryKey = payload.new ? "new" : "old";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload.type === END
					? {
							o: _get(
								rootState,
								`jeet11.jeet11PartnerRechargeHistory.${rechargeHistoryKey}.offset`
							)
					  }
					: {}),
				...(payload.new
					? {
							new: payload.new
					  }
					: {}),
				...(payload.rewardHistory
					? {
							rewardHistory: payload.rewardHistory
					  }
					: {})
			}
		};
		const headers = {
			"x-client-app-type": payload.appName || "JEET11"
		};
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchJeet11PartnerRechargeHistorySuccess, {
						...data.response,
						...payload,
						rechargeHistoryKey
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[RESET_JEET11_PARTNER_RECHARGE_HISTORY.action]: ({ commit }) => {
		commit(fetchJeet11PartnerRechargeHistorySuccess, {
			rechargeHistoryKey: "rewardHistory",
			resetData: true
		});
	},
	[SET_JEET11_USER_PROFILE.action]: ({ commit }, payload) => {
		commit(setJeet11UserProfile, payload);
	},
	[RESET_JEET11_USER_PROFILE.action]: ({ commit }) => {
		commit(setJeet11UserProfile, null);
	},

	[SEND_NOTIFICATION.action]: ({ dispatch, rootState }, payload) => {
		const endPoint =
			BASE_URL + "/jeet11-retail/v1.0.0/sendRetailNotifications";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "SUCCESS" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[DOWNLOAD_INVOICE.action]: ({ dispatch, rootState }, payload) => {
		const endPoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getDistributorInvoice";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					const { response } = data;
					const { msg } = response;
					const { fileUrl } = msg;
					__fileDownload(fileUrl);
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "SUCCESS" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[DOWNLOAD_CREDIT_NOTE.action]: ({ dispatch, rootState }, payload) => {
		const endPoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getDistributorInvoiceCreditNote";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					const { response } = data;
					const { msg } = response;
					const { fileUrl } = msg;
					__fileDownload(fileUrl);
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "SUCCESS" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[DOWNLOAD_GST_INVOICE.action]: ({ dispatch, rootState }, payload) => {
		const endPoint =
			BASE_URL + "/jeet11-retail/v1.0.0/distributorGstInvoice";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endPoint, requestPayload)
			.then(data => {
				if (data.statusCode === 200) {
					const { response } = data;
					const { msg } = response;
					const { fileUrl } = msg;
					if (fileUrl) __fileDownload(fileUrl);
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "SUCCESS" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					const { errMsg: dataErrorMessage } = data;
					return dataErrorMessage;
				}
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[FETCH_JEET11_USERS_BY_RETAILER_ID.action]: (
		{ dispatch, rootState, commit },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/executiveCustomers";
		const customersType = payload.new ? "new" : "old";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload.type === END
					? {
							offset: _get(
								rootState,
								`jeet11.usersByRetailerID.users[${customersType}].offset`
							)
					  }
					: {}),
				...(payload.new
					? {
							new: payload.new
					  }
					: {}),
				...(payload.retailerId
					? {
							retailerId: payload.retailerId
					  }
					: {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchUsersByRetailerIDSuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[RESET_JEET11_USERS_BY_RETAILER_ID.action]: ({ commit }) => {
		commit(resetUsersByRetailerIDSuccess, {});
	},
	[FETCH_RAZORPAY_ACCOUNT_DETAILS.action]: ({
		dispatch,
		rootState,
		commit
	}) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getRazorpayVirtualAccount";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.code === 200 && typeof data.response === "object") {
					commit(fetchRazorpayAccountDetailsSuccess, {
						...data.response
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[CREATE_RAZORPAY_ACCOUNT.action]: (
		{ dispatch, rootState, commit },
		payload
	) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/createRazorpayVirtualAccount";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.code === 200 && typeof data.response === "object") {
					commit(fetchRazorpayAccountDetailsSuccess, {
						...data.response
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_MONTHLY_COMMISSION.action]: ({ dispatch, rootState, commit }) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/monthlyCommission";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				month: new Date().getMonth(),
				year: new Date().getFullYear()
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					const { response } = data;
					commit(fetchMonthlyCommissionSuccess, response);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_PRODUCTS.action]: ({ dispatch, rootState, commit }, payload) => {
		const { isMojProducts, ...restPayload } = payload;
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getProducts";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: restPayload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					const { response } = data;
					const { productsInfo } = response;
					commit(fetchProductsSuccess, {
						products: isMojProducts
							? productsInfo.products
							: productsInfo
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	// eslint-disable-next-line no-unused-vars
	[TRANSFER_COINS.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/transferCoins";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return true;
				} else if (data.errMsg) {
					errMsg = data.errMsg.message;
					return false;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
			});
	},
	[TRANSFER_COINS_FETCH_USER_DATA.action]: async (
		{ dispatch, rootState, commit },
		payload
	) => {
		const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getSharechatUser`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(response => {
				const {
					statusCode,
					errMsg,
					response: userDataResponse
				} = response;
				if (statusCode === 200) {
					commit(fetchTrasferCoinsUserDataSuccess, {
						userData: userDataResponse.userData
					});
					return userDataResponse.userData;
				} else if (errMsg) {
					commit(fetchTrasferCoinsUserDataSuccess, {
						userData: {}
					});
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: errMsg },
						{ root: true }
					);
					return {};
				}
			})
			.catch(err => {
				console.error(err);
			});
	},
	[TRANSFER_COINS_FETCH_USER_DATA_MOJ.action]: async (
		{ dispatch, rootState, commit },
		payload
	) => {
		const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getMojUser`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(response => {
				const {
					statusCode,
					errMsg,
					response: userDataResponse
				} = response;
				if (statusCode === 200) {
					commit(fetchTrasferCoinsUserDataSuccess, {
						userData: userDataResponse.userData.users[0]
					});
					return userDataResponse.userData.users[0];
				} else if (errMsg) {
					commit(fetchTrasferCoinsUserDataSuccess, {
						userData: {}
					});
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: errMsg },
						{ root: true }
					);
					return {};
				}
			})
			.catch(err => {
				console.error(err);
			});
	},
	[FETCH_DISTRIBUTOR_COMMISION.action]: (
		{ rootState, commit },
		{ isRummyOptionSelected, ...payload }
	) => {
		const endpoint =
			BASE_URL +
			`/jeet11-retail/v1.0.0/${
				isRummyOptionSelected
					? "getGameDstrCommision"
					: "getDstrCommission"
			}`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchDistributorCommissionSuccess, {
						...data.response
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg.message;
					commit(fetchDistributorCommissionSuccess, {
						dstrEarning: 0,
						dstrCommission: 0,
						dstrCommissionGmvModel: 0
					});
					return errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
			});
	},
	[FETCH_DSTR_RETAILERS_COMMISSION.action]: (
		{ dispatch, rootState, commit },
		{ type, isRummyOptionSelected, ...payload }
	) => {
		const endpoint =
			BASE_URL +
			`/jeet11-retail/v1.0.0/${
				isRummyOptionSelected
					? "getGameRetailersCommision"
					: "getRetailersCommission"
			}`;
		const offset = _get(
			rootState,
			`jeet11.distributorCommission.nextOffset`
		);
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload || {}),
				...(type === TOP ? {} : { offset })
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchDstrRetailersCommissionSuccess, {
						...data.response,
						type
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_USER_MATCH_HISTORY.action]: (
		{ dispatch, rootState, commit },
		{ type = END, ...payload }
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/completedMatches";
		const offset = _get(rootState, `jeet11.userHistory.matches.nextOffset`);
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload,
				...(type === TOP ? {} : { offset }),
				limit: 10
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchUserMatchHistorySuccess, {
						...data.response,
						type
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_USER_RECHARGE_HISTORY.action]: (
		{ dispatch, rootState, commit },
		{ userId, type = END }
	) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getUserPassbook";
		const offset = _get(rootState, `jeet11.userHistory.recharges.offset`);
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				userId,
				...(type === TOP ? {} : { offset })
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchUserRechargeHistorySuccess, {
						...data.response,
						type
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_RETAILER_COMMISSION.action]: (
		{ dispatch, rootState },
		{ isRummyOptionSelected, ...payload }
	) => {
		const endpoint =
			BASE_URL +
			`/jeet11-retail/v1.0.0/${
				isRummyOptionSelected
					? "getGameRetailerCommision"
					: "getRetailerCommission"
			}`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg.message;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[COMMISSION_PAYOUT.action]: (
		{ dispatch, rootState },
		{ isRummyOptionSelected, ...payload }
	) => {
		const endpoint =
			BASE_URL +
			`/jeet11-retail/v1.0.0/${
				isRummyOptionSelected
					? "initiateGameRetailCommissionPay"
					: "initiateRetailCommissionPay"
			}`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg.message;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_RETAIL_SALARY.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailSalary";
		const { appType, ...rest } = payload;
		const headers = {
			"x-client-app-type": appType || "JEET11"
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: rest
		};
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg.message;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[REVERSE_TRANSACTION.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/reverseTransaction";
		const { appType, ...restPayload } = payload;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: restPayload
		};
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Transaction Reverted Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg.msg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[UPSERT_PROMOTER_MAPPING.action]: ({ dispatch, rootState }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/upsertPromoterMapping";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Mapping Updated Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[GET_NON_VERIFIED_SIGNATURE.action]: ({ dispatch, rootState }, payload) => {
		const endpoint =
			BASE_URL + `/jeet11-${payload}/v1.0.0/nonVerifiedSignatures`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[VERIFY_SIGNATURE.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-finance/v1.0.0/verifySignature";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "SIGNATURE STATUS UPDATED!" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[GET_PENDING_INVOICES.action]: ({ dispatch, rootState }, payload) => {
		const { type, invoiceType, ...updatedPayload } = payload;
		const endpoint = BASE_URL + `/jeet11-${type}/v1.0.0/dstrInvoices`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...updatedPayload,
				type: invoiceType
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[VERIFY_INVOICE.action]: ({ dispatch, rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-finance/v1.0.0/updateDstrInvoice";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "INVOICE STATUS UPDATED!" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[FETCH_RETAIL_SCHEMES.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getScheme";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.code === 200 && typeof data.response === "object") {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_SCHEME_REWARDS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/schemeRewards";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[TRANSFER_SCHEME_REWARD_CASH.action]: (
		{ rootState, dispatch },
		payload
	) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/transferSchemeRewardCash";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Updated Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_USER_SETTINGS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/userSettings";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	}
};

const mutations = {
	[fetchJeet11PartnerWalletDetailsSuccess](
		state,
		{
			walletBalance = 0,
			totalCommissionEarned = 0,
			phoneNo,
			userType,
			referralEarning = 0,
			shopType = "",
			retailerName = "",
			tsmNumber = "",
			retailScheme = "",
			gameRetailScheme = "",
			retailerMappedId = "",
			creditLimit = 0,
			creditUsed = 0,
			signatureVerified = null,
			signatureRemarks = "",
			shopStatus = "",
			remarks
		}
	) {
		state.jeet11PartnerDetails = {
			walletBalance: Math.round(walletBalance * 100) / 100,
			totalCommissionEarned:
				Math.round(totalCommissionEarned * 100) / 100,
			phoneNo,
			userType,
			referralEarning,
			shopType,
			retailerName,
			tsmNumber,
			retailScheme,
			gameRetailScheme,
			retailerMappedId,
			creditLimit,
			creditUsed,
			signatureVerified,
			signatureRemarks,
			shopStatus,
			remarks
		};
	},

	[fetchJeet11UserSuccess](state, payload) {
		state.jeet11User = payload;
	},

	[jeet11TransactionHistorySuccess](
		state,
		{ transactions, offset, type = TOP }
	) {
		transactions = transactions.map(el => {
			return {
				...el,
				paymentType: el.paymentType === "C" ? "credit" : "debit",
				teamName: el.user ? el.user.teamName : el.userId,
				createdOn: _getDateTimeFormat(el.createdOn)
			};
		});
		if (type === TOP) {
			state.jeet11PartnerTransactionHistory = {
				list: [...transactions],
				offset
			};
		} else if (type === END) {
			state.jeet11PartnerTransactionHistory = {
				list: [
					...state.jeet11PartnerTransactionHistory.list,
					...transactions
				],
				offset
			};
		}
	},

	[payJeet11UserSuccess](
		state,
		{ retailerAmount, totalCommissionEarned, referralEarning }
	) {
		state.jeet11PartnerDetails = {
			...state.jeet11PartnerDetails,
			walletBalance: retailerAmount,
			totalCommissionEarned,
			referralEarning
		};
	},

	[resetJeet11Module](state) {
		Object.keys(initialState).forEach(key => {
			state[key] = initialState[key];
		});
	},

	[fetchJeet11DistributorRetailerListSuccess](
		state,
		{ data, offset, type = TOP }
	) {
		if (type === TOP) {
			state.jeet11DistributorRetailerList = {
				list: [...data],
				offset
			};
		} else if (type === END) {
			state.jeet11DistributorRetailerList = {
				list: [...state.jeet11DistributorRetailerList.list, ...data],
				offset
			};
		}
	},

	[fetchJeet11RetailerTransactionHistorySuccess](
		state,
		{ transactions, offset, type = TOP }
	) {
		transactions = transactions.map(el => {
			return {
				...el,
				paymentType: el.paymentType === "C" ? "credit" : "debit",
				teamName: el.user ? el.user.teamName : el.userId,
				createdOn: _getDateTimeFormat(el.createdOn)
			};
		});
		if (type === TOP) {
			state.jeet11PartnerRetailerTransactionHistory = {
				list: [...transactions],
				offset
			};
		} else if (type === END) {
			state.jeet11PartnerRetailerTransactionHistory = {
				list: [
					...state.jeet11PartnerRetailerTransactionHistory.list,
					...transactions
				],
				offset
			};
		}
	},

	[fetchRetailBannersSuccess](state, { banners }) {
		state.jeet11RetailBanners = banners;
	},

	[fetchCaptainTargetsSuccess](state, { targets }) {
		state.jeet11CaptainTargets = targets;
	},

	[fetchUserStoriesSuccess](state, { stories, type = TOP }) {
		if (type === TOP) {
			state.userStories = {
				...state.userStories,
				data: stories,
				canLoadMoreStories: stories.length ? true : false
			};
		} else if (type === END) {
			state.userStories = {
				...state.userStories,
				data: [...state.userStories.data, ...stories],
				canLoadMoreStories: stories.length ? true : false
			};
		}
	},

	[deleteUserStorySuccess](state, { storyId }) {
		const newStoriesData = state.userStories.data.filter(
			story => story.storyId !== storyId
		);
		state.userStories = {
			...state.userStories,
			data: newStoriesData
		};
	},

	[fetchJeet11PartnerRechargeHistorySuccess](
		state,
		{
			totalRewardCommission,
			customers,
			nextOffset,
			rechargeHistoryKey,
			type = TOP,
			resetData = false
		}
	) {
		if (resetData) {
			state.jeet11PartnerRechargeHistory = {
				...state.jeet11PartnerRechargeHistory,
				[rechargeHistoryKey]: {
					customers: [],
					offset: undefined,
					totalRewardCommission: null
				}
			};
			return;
		}
		customers = customers.map(el => {
			return {
				...el,
				updatedOn: _getDateTimeFormat(el.updatedOn)
			};
		});
		if (type === TOP) {
			state.jeet11PartnerRechargeHistory = {
				...state.jeet11PartnerRechargeHistory,
				[rechargeHistoryKey]: {
					customers: [...customers],
					offset: nextOffset,
					totalRewardCommission
				}
			};
		} else if (type === END) {
			state.jeet11PartnerRechargeHistory = {
				...state.jeet11PartnerRechargeHistory,
				[rechargeHistoryKey]: {
					customers: [
						...state.jeet11PartnerRechargeHistory[
							rechargeHistoryKey
						].customers,
						...customers
					],
					offset: nextOffset,
					totalRewardCommission
				}
			};
		}
	},
	[setJeet11UserProfile](state, payload) {
		state.jeet11PartnerRechargeHistory = {
			...state.jeet11PartnerRechargeHistory,
			jeet11UserProfile: payload
		};
	},
	[fetchUsersByRetailerIDSuccess](state, payload) {
		const customersType = payload.new ? "new" : "old";
		if (payload.type === TOP) {
			state.usersByRetailerID = {
				...state.usersByRetailerID,
				users: {
					...state.usersByRetailerID.users,
					[customersType]: {
						list: [...payload.customers],
						offset: payload.nextOffset
					}
				}
			};
		} else {
			state.usersByRetailerID = {
				...state.usersByRetailerID,
				users: {
					...state.usersByRetailerID.users,
					[customersType]: {
						list: [
							...state.usersByRetailerID.users[customersType]
								.list,
							...payload.customers
						],
						offset: payload.nextOffset
					}
				}
			};
		}
	},
	[resetUsersByRetailerIDSuccess](state) {
		state.usersByRetailerID = {
			users: {
				new: {
					list: [],
					offset: null
				},
				old: {
					list: [],
					offset: null
				}
			}
		};
	},
	[fetchRazorpayAccountDetailsSuccess](state, payload) {
		state.razorpayAccountDetails = {
			...payload
		};
	},
	[fetchMonthlyCommissionSuccess](state, payload) {
		state.monthlyCommission = { ...payload };
	},
	[fetchProductsSuccess](state, payload) {
		const { products } = payload;
		state.sharechatProducts = products;
	},
	[fetchTrasferCoinsUserDataSuccess](state, payload) {
		const { userData } = payload;
		state.transferCoinsUserData = userData;
	},
	[fetchDistributorCommissionSuccess](state, payload) {
		state.distributorCommission = {
			...state.distributorCommission,
			commissionEarned: payload.dstrEarning,
			dstrCommission: {
				oldModel: payload.dstrCommission,
				newModel: payload.dstrCommissionGmvModel
			},
			selfGmv: payload.selfGmv,
			totalGmv: payload.totalGmv
		};
	},
	[fetchDstrRetailersCommissionSuccess](state, { type = END, ...payload }) {
		if (type === END) {
			state.distributorCommission = {
				...state.distributorCommission,
				nextOffset: payload.nextOffset,
				retailerEntries: [
					...state.distributorCommission.retailerEntries,
					...payload.retailerDashboard
				]
			};
		} else if (type === TOP) {
			state.distributorCommission = {
				...state.distributorCommission,
				nextOffset: payload.nextOffset,
				retailerEntries: [...payload.retailerDashboard]
			};
		}
	},
	[fetchUserMatchHistorySuccess](state, { type = END, ...payload }) {
		const {
			completedMatches = [],
			teamsData = {},
			tournamentsData = {},
			offset = null
		} = payload;

		if (type === TOP) {
			state.userHistory.matches = {
				completedMatches,
				teamsData,
				tournamentsData,
				offset
			};
		} else if (type === END) {
			state.userHistory.matches = {
				completedMatches: [
					...state.userHistory.matches.completedMatches,
					...completedMatches
				],
				teamsData: {
					...state.userHistory.matches.teamsData,
					...teamsData
				},
				tournamentsData: {
					...state.userHistory.matches.tournamentsData,
					...tournamentsData
				},
				offset
			};
		}
	},
	[fetchUserRechargeHistorySuccess](state, { type = END, ...payload }) {
		if (type === END) {
			state.userHistory.recharges = {
				list: [
					...state.userHistory.recharges.list,
					...payload.passbookEntries
				],
				offset: payload.offset
			};
		} else if (type === TOP) {
			state.userHistory.recharges = {
				list: [...payload.passbookEntries],
				offset: payload.offset
			};
		}
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
